import { db } from '../firebase';
import { addDoc, collection } from 'firebase/firestore';

export const logGresku = async ({ tip, poruka, stack, strana, korisnik }) => {
  try {
    await addDoc(collection(db, 'logi'), {
      timestamp: new Date().toISOString(),
      tip: tip || 'greska',
      poruka: String(poruka || '').slice(0, 600),
      stack: String(stack || '').slice(0, 3000),
      strana: strana || '?',
      korisnik: korisnik || 'nepoznat',
      url: window.location.href,
    });
  } catch (e) {
    // ne loguj greske logger-a
    console.error('Logger greška:', e);
  }
};
